<template>
    <div class="p-quantity">
        <vue-element-loading :active="atualizandoQuantidadeProduto"/>
        <div class="btn-quantity">
            <MinusBox @click="subtrai(produto)" class="md-28 qb-txt-color-3" />
        </div>
        <div class="input-quantity">
            <input type="number" :value="produto.quantity" name="quantity" @keyup.enter="inputAlterado(produto)" @keydown.tab="inputAlterado(produto)" min="1">
        </div>
        <div class="btn-quantity">
            <PlusBox @click="incrementa(produto)" class="md-28 qb-txt-color-3"/>
        </div>
    </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import PlusBox from "vue-material-design-icons/PlusBox.vue";
import MinusBox from "vue-material-design-icons/MinusBox.vue";
import axios from "axios";
import { baseApiUrl/*, userKey*/ } from "@/global";
export default {
    components:{
        VueElementLoading,
        PlusBox,
        MinusBox
    },
    props:{
        produto: {
            required: true,
        }
    },
    data(){
        return{
            atualizandoQuantidadeProduto: false,
            quantidadeTemp: 0
        }
    },
    methods:{
        incrementa(produto){
            this.quantidadeTemp = produto.quantity;
            produto.quantity++;
            this.update(produto);
        },
        subtrai(produto){
            if(produto.quantity == 1) return
            this.quantidadeTemp = produto.quantity;
            produto.quantity--;
            this.update(produto);
        },
        inputAlterado(produto){
            if(event.target.value < 1){
                event.target.value = 1;
            }
            if(event.target.value != produto.quantity){
                this.quantidadeTemp = produto.quantity;
                produto.quantity = parseInt(event.target.value)
                this.update(produto);
            }
        }, 
        update(produto){
            this.atualizandoQuantidadeProduto=true;
            axios.put(`${ baseApiUrl }/orders/`,produto)
                .then(res => {
                    if(res.data.valid){
                        this.$awn.success(res.data.message, {labels: {success: res.data.title }})
                        this.$emit('atualizaTotal');
                    }else{
                        this.$awn.warning(res.data.message, {labels: {warning: res.data.title }})
                        produto.quantity = this.quantidadeTemp;
                    }
                    this.atualizandoQuantidadeProduto=false
               })
                .catch(error => console.log(error))
                .finally(/*sempre executa*/)
        }
    }
}
</script>

<style scoped>
 .input-quantity input{
    width: 100%;
    border: none;
    border-bottom: 1px solid #efefefc2;
    text-align: center;
    padding-bottom: 4px;
}

.p-quantity{
    display: flex;
    justify-content: center;
    border: 1px solid #808080c2;
    padding: 4px;
    margin: 0px 4px;
}

input[type=number] {
    -moz-appearance:textfield;
}
</style>